<template>
  <div>
	<div class="searchWrapper">
		<!-- <el-row>
			<form v-on:submit="getfilteredData">
			<el-col :span="20">
				<el-input
				placeholder="Input"
				v-model="search"
				v-on:keyup="getfilteredData"
				clearable>
				</el-input>
			</el-col>
			<el-col :span="2">
				<el-button type="submit" icon="el-icon-search" class="searchButton">Search</el-button>
			</el-col>
			</form>
		</el-row> -->
		<el-row class="searchCheckBoxRow">
			<el-col :span="24">
				<el-checkbox 
					v-model="tag.checked" 
					:label="tag.value" 
					border 
					size="medium" 
					class="searchCheckbox" 
					v-on:change="getfilteredData" v-for="(tag, index) in tags" 
					:key="index">
				</el-checkbox>
			</el-col>
		</el-row>
	</div>
	<div v-if="noResult" class="cardNoresult">
		<el-alert
			title="No information found"
			type="info"
			description="There is no information found with this filters. Please uncheck filters to reveal..."
			:closable="false">
		</el-alert>
	</div>
	<transition-group name="fadeLeft" tag="div" class="cardsWrapper">
		<el-card class="boxCard" v-for="(item, index) in filteredData" v-bind:key="index" style="animation-duration: 0.3s">
			<div slot="header" class="clearfix">
				<span>{{ item.name }}</span>
			</div>
			<div>
				<div class="cardCaption">{{ item.caption }}</div>
				<div class="cardChart">
					<img v-if="item.chartType == 'gender'" src="../assets/images/charts/gender.png" alt="" />
					<img v-if="item.chartType == 'bars'" src="../assets/images/charts/bars.png" alt="" />
					<img v-if="item.chartType == 'agegroups'" src="../assets/images/charts/agegroups.png" alt="" />
					<img v-if="item.chartType == 'education'" src="../assets/images/charts/education.png" alt="" />
					<img v-if="item.chartType == 'maritialstatus'" src="../assets/images/charts/maritialstatus.png" alt="" />
					<img v-if="item.chartType == 'dailyusers'" src="../assets/images/charts/dailyusers.png" alt="" />
					<img v-if="item.chartType == 'topfanspercity'" src="../assets/images/charts/topfanspercity.png" alt="" />
					<img v-if="item.chartType == 'aera-views-over-time'" src="../assets/images/charts/aera-views-over-time.png" alt="" />
					<img v-if="item.chartType == 'sentiment-morenegative'" src="../assets/images/charts/sentiment-morenegative.png" alt="" />
					<img v-if="item.chartType == 'sentiment-morepositive'" src="../assets/images/charts/sentiment-morepositive.png" alt="" />
					<img v-if="item.chartType == 'area'" src="../assets/images/charts/area.png" width="100%" alt="" />
				</div>
				<div class="cardTags">
					<el-tag 
						size="small" 
						v-for="(tag, index) in item.tags" 
						v-bind:key="index"
						class="cardTagColor"
						>{{ tag }}
					</el-tag>
				</div>
			</div>
		</el-card>
	</transition-group>
  </div>
</template>

<script>
import data from '../data/fastinsights';
require('vue2-animate/dist/vue2-animate.min.css');

export default {
	components: {
		// ...
	},

	computed: {
		selectedFilters: function () {
			let filters = [];
			let checkedFiters = this.tags.filter(obj => obj.checked);
			checkedFiters.forEach(element => {
				filters.push(element.value);
			});
			return filters;
		}
	},

	data () {
		return {
			items: [
				0,
				1,
				2,
				3,
				4
			],
			noResult: false,
			filteredData: [],
			search: '',
			tags: [
				{
					checked: false,
					value: 'general'
				},
				{
					checked: false,
					value: 'sentiment'
				},
				{
					checked: false,
					value: 'active'
				},
				{
					checked: false,
					value: 'facebook'
				},
				{
					checked: false,
					value: 'twitter'
				},
				{
					checked: false,
					value: 'linkedin'
				},
				{
					checked: false,
					value: 'youtube'
				}
			],
			tagColorstags: {
				language: 'light',
				framework: 'dark',
				frontend: 'success',
				backend: 'danger',
				mobile: 'warning',
				web: 'secondary',
				hybrid: 'info',
				database: 'danger'
			}
		};
	},

	methods: {
		sanitize (s) {
			return s.replace(/ /g, '-');
		},

		getfilteredData: function () {
			this.filteredData = data;
			let filteredDataByfilters = [];
			let filteredDataBySearch = [];

			if (this.selectedFilters.length > 0) {
				filteredDataByfilters = this.filteredData.filter(obj => this.selectedFilters.every(val => obj.tags.indexOf(val) >= 0));
				this.filteredData = filteredDataByfilters;
				if (this.filteredData.length === 0) {
					this.noResult = true
				} else if (this.filteredData.length > 0) {
					this.noResult = false
				}
			}

			if (this.search !== '') {
				filteredDataBySearch = this.filteredData.filter(obj => obj.name.indexOf(this.search.toLowerCase()) >= 0);
				this.filteredData = filteredDataBySearch;
			}
		}
	},

	mounted () {
		this.getfilteredData();
	}
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* 
.boxCardContent {
  animation: appear .2s;
  animation-delay: .3s;
  opacity: 0;
} */
/* .router-anim-leave-active {
  animation: going .2s;
} */

@keyframes appear {
  from {
	opacity: 0;
  }
  to {
	opacity: 1;
  }
}

</style>
